var generateStyle = function generateStyle(componentTheme) {
  return {
    canvasWrapper: {
      maxWidth: '100%',
      maxHeight: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    canvas: {
      '&:hover': {
        cursor: 'crosshair'
      }
    },
    shapeColor: componentTheme.shapeColor
  };
};
export default generateStyle;